import { SHOW_STAFF_DETAILS } from 'actionTypes/staffDetailsActionTypes';

export const setStaffDetails = (payload) => ({
  type: SHOW_STAFF_DETAILS,
  payload,
});
export default {
  setStaffDetails,
};
